import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "antd";
import { useMutation } from "@apollo/client";
import { LANGUAGE_DELETE } from "graphql/mutation/language-gql";
import { GET_LANGUAGES, GET_LANGUAGES_ALL, GET_LANGUAGES_PAGINATED } from "graphql/query/language-gql";
import { errorNotification, successNotification } from "components/request-result";
import { EntityRemoveButton, Localize } from "components/service";
import LanguageConst from "../../language-const";


const basePath = LanguageConst.basePath;

const LanguageDeleteForm = ({ language }) => {

    const history = useHistory();

    const [ languageDeleteRequest, { loading } ] = useMutation(LANGUAGE_DELETE, {
        refetchQueries: [ GET_LANGUAGES, GET_LANGUAGES_ALL, GET_LANGUAGES_PAGINATED ],
        update(cache, { data }) {
            const {
                languageDelete: {
                    label,
                    message
                }
            } = data;

            successNotification({
                title: label,
                description: message
            });

            history.push(`${ basePath }`);
        },
        onError(error) {
            errorNotification(error);
        }
    });

    return (
        <EntityRemoveButton
            modalButton={
                <Button className="ant-btn-secondary">
                    <Localize>LANGUAGE.Button_Text_Delete</Localize>
                </Button>
            }
            nameEntity={ Localize({ children: "ENTITY.Modal_Title_Language" }).props.children }
            dataNameEntity={ language.label || language.slug }
            loading={ loading }
            deleteMutation={ languageDeleteRequest }
            variables={ {
                id: language.id,
            } }
        />
    );
};

export default LanguageDeleteForm;
